import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import Ad from '~/components/Shared/Ads/Ad';

type AdType = {
  id: string;
  location: 'stickyBottom' | null | undefined;
};

/**
 * Ad component for ads that exist OUTSIDE the Article Builder
 */
export default component$<AdType>(({ id, location }): JSX.Element => {
  // Need to use article from AppData because the ArticleContext isn't always set here
  const { article } = useContext(AppDataContext);
  if (!article) return <></>;

  // Check if ads are disabled
  if (
    article.metadata?.commercialTags &&
    article.metadata?.commercialTags.includes('no-ads')
  )
    return <></>;

  return <Ad id={id} location={location} />;
});
